import { render, staticRenderFns } from "./Atencion.vue?vue&type=template&id=8a90a07e"
import script from "./Atencion.vue?vue&type=script&lang=js"
export * from "./Atencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports